export default __webpack_public_path__ + "static/media/laliga-logo-vertical_EN.6602ca8e.svg";